export default __webpack_public_path__ + "static/media/Obando.d709be16.jpg";